import { FormControlLabel, Switch } from "@mui/material";
import { switchElements } from "../../responsePage/rptemplate";

function CSSwitches({ components, handleSwitch, selectedComponentIndex }) {

  return (
    <>
      {switchElements.map((el) => {
        if (components[selectedComponentIndex]?.[el.name] !== undefined) {
          return (
            <FormControlLabel
              key={el.name}
              labelPlacement="start"
              control={
                <Switch
                  id={el.name}
                  name={el.name}
                  disabled={
                    components[selectedComponentIndex]?.[el.disabledIfNot] !==
                      undefined &&
                    components[selectedComponentIndex]?.[el.disabledIfNot] ===
                      false
                  }
                  checked={components[selectedComponentIndex]?.[el.name]}
                  onChange={(e) => handleSwitch(e.target.checked, el.name)}
                />
              }
              label={el.label}
            />
          );
        }
      })}
    </>
  );
}

export default CSSwitches;